export default {
    mavinName: [
        { required: true, trigger: 'blur', message: '请输入[姓 名]' }
    ],
    nation: [{ required: true, trigger: 'blur', message: '请选择[民 族]' }],
    deptName: [
        { required: true, trigger: 'blur', message: '请选择[工作单位]' }
    ],
    clan: [{ required: true, trigger: 'blur', message: '请选择[政治面貌]' }],
    bornId: [
        { required: true, trigger: 'blur', message: '请选择[籍贯]' }
    ],
    workTime: [
        { required: true, trigger: 'blur', message: '请选择[参加工作时间]' }
    ],
    idCard: [
        { required: true, trigger: 'blur', message: '请输入[身份证号码]' }
    ],
    mobile: [
        { required: true, trigger: 'blur', message: '请输入[手机号码]' }
    ],
    appellationId: [
        { required: true, trigger: 'blur', message: '请选择[现任职称]' }
    ],
    appellationDate: [
        { required: true, trigger: 'blur', message: '请选择[职称取得时间]' }
    ],
    headship: [
        { required: true, trigger: 'blur', message: '请输入[现聘岗位名称（职务）]' }
    ],
    deptWorkTime: [
        { required: true, trigger: 'blur', message: '请选择[进入现单位工作时间]' }
    ]
}